import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '@env/environment';
import { Observable } from "rxjs";
import { GTCDefinitionDto } from "./gtc-definition";

@Injectable({
  providedIn: 'root',
})
export class GtcService {
  private baseUrl: string = environment.baseApiUrl;

  constructor(private http: HttpClient) {}

    /**
     * Get a company's CGV
     * @param companyCode Code of the company
     */
    public GetDocumentsCGV(companyCode: string, guid: string): Observable<Blob> {
        return this.http.get(`${this.baseUrl}/companies/${companyCode}/GetTermsOfSales/${guid}`, {
            responseType: 'blob'
        });
    }

    /**
     * Récupère la définition actuelle des CGV applicable à la date du jour
     * @param companyCode Code de la société
     * @returns Observable<GTCDefinitionDto>
     */
    public GetCurrentCGVDefinition(companyCode: string): Observable<GTCDefinitionDto> {
      const url = `${this.baseUrl}/companies/${companyCode}/GetCurrentTermsOfSalesDefinition`;
      return this.http.get<GTCDefinitionDto>(url);
    }
}
